import classNames from 'classnames'
import React from 'react'

import { TeamMember } from '../logic/shared-types'

import MeasurImage from './MeasurImage'

import './Avatar.scss'

interface Props {
  className?: string
  member: TeamMember | null
  variant?: 'rounded'
  size?: number
}

export const Avatar = ({ className, member, variant, size = 170 }: Props) => {
  const baseClass = classNames('avatar', { [`avatar--${variant}`]: variant })
  const img = member?.avatar ? (
    <MeasurImage
      image={{
        ...member.avatar.gatsbyImageData,
        height: size,
        width: size,
      }}
      alt={member.name.full}
      className={classNames(baseClass, className)}
    />
  ) : (
    <img
      src="/avatar-placeholder.svg"
      alt="Avatar"
      className={classNames(baseClass, 'avatar--placeholder', className)}
    />
  )
  if (member?.profileUrl) {
    return <a href={member.profileUrl}>{img}</a>
  }
  return img
}
